import { styled, TextField } from "@mui/material";
import { GridRenderEditCellParams, useGridApiContext } from "@mui/x-data-grid";
import React, { ChangeEvent, FC, useEffect, useState } from "react";

interface TableTextEditComponentProps {
  renderParams: GridRenderEditCellParams;
  maxLength: number;
}

export const TableTextEditComponent: FC<TableTextEditComponentProps> = ({
  renderParams,
  maxLength,
}) => {
  const { id, value: valueProp, field } = renderParams;
  const [value, setValue] = useState(valueProp);
  const apiRef = useGridApiContext();

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    apiRef.current.setEditCellValue({
      id,
      field,
      value: newValue,
      debounceMs: 200,
    });
    setValue(newValue);
  };

  useEffect(() => {
    setValue(valueProp);
  }, [valueProp]);

  return (
    <StyledTextField
      type="text"
      fullWidth
      value={value}
      onChange={handleChange}
      autoFocus
      inputProps={{ maxLength: maxLength }}
    />
  );
};

const StyledTextField = styled((props: any) => <TextField {...props} />)(
  () => ({
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        margin: "0.5rem",
      },
    },
  })
);
